<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit()">
          新增
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="部门名称"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      stripe
      @selection-change="setSelectRows"
    >
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="branchs.length > 1"
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="名称"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="130"
      >
        <template #default="{ row }">
          <el-button class="mr-10" type="text" @click="handleEdit(row)">
            修改
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { delDepartment, getAllBranchs, getDepartments, } from '@/api/branch'
import Edit from './edit'
export default {
  name: 'BranchRole',
  components: { Edit, },
  data() {
    return {
      moment,
      branchs: [],
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        branchId: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/branch/department') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
    this.getBranchs()
  },
  methods: {
    async getBranchs() {
      this.branchs = await getAllBranchs()
      this.branchs.unshift({
        title: '集团',
        branchId: 'group',
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleCommand(command) {
      if (command.cmd === 'delete') this.handleDelete(command.item)
    },
    handleEdit(row) {
      if(row && row.departmentId)
        this.$refs['edit'].showEdit(row)
      else
        this.$refs['edit'].showEdit()
    },
    handleDelete(row) {
      this.$baseConfirm(
        `你确定要删除部门：${row.title} 吗`,
        null,
        async () => {
          await delDepartment({ departmentId: row.departmentId })
          this.$baseMessage(
            '删除部门成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          await this.fetchData()
        }
      )
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getDepartments(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .wrap .left-panel {
  align-items: inherit !important;
}
.mr-10 {
  margin-right: 20px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  width: 40px;
  height: 40px;
}
</style>
